import { Timeline } from '@material-ui/icons'

export default (props) => <Timeline {...props} />
